module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_3_EMPRENDIMIENTO.af86c9dd.jpg";